import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import Card from "components/card";

const PieChartCard = ({ movies, series, animation }) => {
  const total = movies + series + animation;
  const moviePct = total === 0 ? 0 : Math.round((movies / total) * 100);
  const seriesPct = total === 0 ? 0 : Math.round((series / total) * 100);
  const animationPct = total === 0 ? 0 : Math.round((animation / total) * 100);

  const dynamicChartData = [moviePct, seriesPct, animationPct];
  const dynamicChartOptions = {
    labels: ["Movies", "Series", "Animation"],
    colors: ["#4318FF", "#6AD2FF", "#FFB547"],
    chart: {
      width: "50px",
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    hover: { mode: null },
    plotOptions: {
      donut: {
        expandOnClick: false,
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    fill: {
      colors: ["#4318FF", "#6AD2FF", "#FFB547"],
    },
    tooltip: {
      enabled: true,
      theme: "dark",
    },
  };

  return (
    <Card extra="rounded-[20px] p-3">
      <div className="flex flex-row justify-between px-3 pt-2">
        <div>
          <h4 className="text-lg font-bold text-navy-700 dark:text-white">
            Catalog Content
          </h4>
        </div>
      </div>

      <div className="mb-auto flex h-[220px] w-full items-center justify-center">
        <PieChart options={dynamicChartOptions} series={dynamicChartData} />
      </div>
      <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-brand-500" />
            <p className="ml-1 text-sm font-normal text-gray-600">Movies</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
            {moviePct}%
          </p>
        </div>

        <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[#6AD2FF]" />
            <p className="ml-1 text-sm font-normal text-gray-600">Series</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
            {seriesPct}%
          </p>
        </div>

        <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[#FFB547]" />
            <p className="ml-1 text-sm font-normal text-gray-600">Animation</p>
          </div>
          <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
            {animationPct}%
          </p>
        </div>
      </div>
    </Card>
  );
};

export default PieChartCard;
